export const CARD_MAX_AGE_DAYS = 14

type Filterable<T> = {
  gte(column: string, value: string): T
  or(filters: string): T
}

/** Keeps only lane cards a customer can still book: not departed, price re-seen lately, not withdrawn by the source. */
export function bookable<T extends Filterable<T>>(query: T, fromDate: string, today: string): T {
  const minSeen = new Date(Date.now() - CARD_MAX_AGE_DAYS * 86_400_000).toISOString()
  return query
    .gte('etd', fromDate)
    .gte('last_seen_at', minSeen)
    .or(`valid_to.is.null,valid_to.gte.${today}`)
}
